import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Card from '../../components/Card';
import BaseButton from '../../components/BaseButton';

import icon from '../../assets/error.svg';

export default function ErrorScreen() {
  const { errorText } = useSelector((state) => state.error);
  const { transferId } = useSelector((state) => state.transfer);
  const dispatch = useDispatch();

  const handleTransferAgain = () => {
    dispatch({ type: 'RESET' });
  };

  const contactSupport = () => {
    let href = 'mailto:support@flom.co';

    if (transferId) {
      href += `?subject=I need support with transaction (${transferId})`;
    }

    window.location.href = href;
  };

  return (
    <Card>
      <div className="receipt-sent">
        <div className="icon">
          <img src={icon} alt="error" />
        </div>
        <div className="info-text">{errorText}</div>
        <BaseButton onClick={handleTransferAgain}>Try again</BaseButton>
        <BaseButton outline onClick={contactSupport}>
          Contact support
        </BaseButton>
      </div>
    </Card>
  );
}
